import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { NOT_ALLOWED_ORGANIZATION } from 'app/app.constants';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    constructor(private router: Router, private route: ActivatedRoute) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401 || err.status === 403) {
                            // console.log(this.route);

                            this.router.navigate(['accessdenied']);
                        }

                        if (err.status === 500) {
                            this.router.navigate(['error'], {
                                state: {
                                    message: err.error.message,
                                    detail: err.error.detail,
                                    stacktrace: err.error.stacktrace
                                }
                            });
                        }

                        if (err.status === 404) {
                            this.router.navigate(['404']);
                        }

                        if (err.status === 406 && err.error.message === NOT_ALLOWED_ORGANIZATION) {
                            this.router.navigate(['nonConsentito']);
                        }
                    }
                }
            )
        );
    }
}
